<template>
  <section class="section">
    <div class="glass-container animate__animated animate__fadeIn">
      <div class="level mb-6">
        <div class="level-left">
          <div>
            <h1 class="title is-2 has-text-white mb-2">Productos</h1>
            <p class="subtitle is-6 has-text-grey-lighter">Administra los productos de cada restaurante participante</p>
          </div>
        </div>
        <div class="level-right">
          <b-button 
            type="is-primary" 
            icon-left="plus" 
            class="is-rounded glass-btn"
            @click="abrirModal(null)"
          >
            Nuevo Producto
          </b-button>
        </div>
      </div>

      <!-- Filtros -->
      <div class="columns mb-4">
        <div class="column is-4">
          <b-field label="Filtrar por Evento" label-position="on-border" class="glass-field">
            <b-select v-model="idEvento" @input="obtenerProductos" expanded class="is-rounded">
              <optgroup label="Selecciona un evento">
                <option :value="null">Todos los productos</option>
                <option v-for="e in eventos" :key="e.id" :value="e.id">
                  {{ e.nombre }} {{ e.activo == 1 ? '(Activo)' : '' }}
                </option>
              </optgroup>
            </b-select>
          </b-field>
        </div>
      </div>

      <div class="table-container glass-table">
        <b-table 
          :data="productos" 
          :hoverable="true" 
          :loading="cargando"
          mobile-cards
          paginated
          per-page="10"
        >
          <b-table-column field="foto" label="Foto" v-slot="props" width="80">
            <figure class="image is-48x48 shadow-soft">
              <img :src="props.row.foto || defaultFoto" alt="producto" class="is-rounded" style="object-fit: cover; height: 48px;">
            </figure>
          </b-table-column>

          <b-table-column field="nombre" label="Producto" v-slot="props">
            <span class="has-text-weight-bold">{{ props.row.nombre }}</span>
          </b-table-column>

          <b-table-column field="nombre_restaurante" label="Restaurante" v-slot="props">
            <b-tag type="is-dark" class="is-rounded glass-tag-info">{{ props.row.nombre_restaurante }}</b-tag>
          </b-table-column>

          <b-table-column field="activo" label="Estado" v-slot="props" centered>
            <span
              class="tag is-rounded"
              :class="props.row.activo == 1 ? 'is-success' : 'is-danger'"
            >
              {{ props.row.activo == 1 ? 'Activo' : 'Inactivo' }}
            </span>
          </b-table-column>

          <b-table-column field="acciones" label="Acciones" v-slot="props" centered>
            <div class="buttons is-centered">
              <b-button
                type="is-info"
                size="is-small"
                icon-left="pencil"
                class="is-rounded glass-action"
                @click="abrirModal(props.row)"
              >
                Editar
              </b-button>
              <b-button
                type="is-danger"
                size="is-small"
                icon-left="trash"
                class="is-rounded glass-action"
                @click="confirmarEliminacion(props.row.id)"
              >
                Eliminar
              </b-button>
            </div>
          </b-table-column>

          <template #empty>
            <div class="has-text-centered py-6">
              <b-icon icon="food-off" size="is-large" class="has-text-grey-light"></b-icon>
              <p class="has-text-grey mt-2">No se encontraron productos vinculados.</p>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <b-modal :active.sync="modalActivo" has-modal-card :can-cancel="['escape', 'x', 'outside']">
      <form-producto
        :productoProp="productoActual"
        :restauranteId="restauranteId"
        :idEventoProp="idEvento"
        @registrar="registrarProducto"
      />
    </b-modal>
  </section>
</template>

<script>
import FormProducto from './FormProducto.vue';
import HttpService from '../../Servicios/HttpService';
import Swal from 'sweetalert2';

export default {
  name: 'ProductosComponent',
  components: { FormProducto },
  data() {
    return {
      productos: [],
      eventos: [],
      idEvento: null,
      cargando: false,
      productoActual: null,
      modalActivo: false,
      restauranteId: 1,
      defaultFoto: '../api/imgproductos/sinimagen.webp'
    };
  },
  mounted() {
    this.cargarDatosIniciales();
  },
  methods: {
    cargarDatosIniciales() {
      this.cargando = true;
      HttpService.registrar('eventos.php', { accion: 'actual' })
        .then(eventoActual => {
          if (eventoActual) this.idEvento = eventoActual.id;
          
          return Promise.all([
            HttpService.registrar('eventos.php', { accion: 'obtener' }),
            this.obtenerProductos()
          ]);
        })
        .then(([eventos]) => {
          this.eventos = eventos || [];
          this.cargando = false;
        });
    },
    obtenerProductos() {
      this.cargando = true;
      return Promise.all([
        HttpService.registrar('productos.php', { accion: 'obtener', id_evento: this.idEvento }),
        HttpService.registrar('productos.php', { accion: 'obtener_fotos' })
      ]).then(([productos, fotos]) => {
        const fotoMap = {};
        (fotos || []).forEach(f => {
          if (!fotoMap[f.producto_id] || f.posicion === 1) {
            fotoMap[f.producto_id] = f;
          }
        });
        this.productos = (productos || [])
          .map(p => ({
            ...p,
            foto: fotoMap[p.id] ? fotoMap[p.id].url : '',
            nombre_restaurante: p.nombre_restaurante || (fotoMap[p.id] ? fotoMap[p.id].nombre_restaurante : '')
          }));
        this.cargando = false;
      });
    },
    registrarProducto(producto) {
      this.cargando = true;
      const accion = producto.id ? 'editar' : 'registrar';
      HttpService.registrar('productos.php', { accion, producto })
        .then(res => {
          if (res) {
            Swal.fire({
              icon: 'success',
              title: producto.id ? 'Actualizado' : 'Registrado',
              timer: 2000,
              showConfirmButton: false
            });
            this.productoActual = null;
            this.modalActivo = false;
            this.obtenerProductos();
          }
        });
    },
    abrirModal(p) {
      if (p) {
        this.cargando = true;
        HttpService.registrar('productos.php', { accion: 'obtener_fotos' })
          .then(fotos => {
            const f = (fotos || [])
              .filter(ft => ft.producto_id == p.id)
              .sort((a, b) => a.posicion - b.posicion)
              .map(ft => ft.url);
            this.productoActual = { ...p, activo: !!Number(p.activo), fotos: f };
            this.modalActivo = true;
            this.cargando = false;
          });
      } else {
        this.productoActual = null;
        this.modalActivo = true;
      }
    },
    confirmarEliminacion(id) {
      Swal.fire({
        title: '¿Eliminar producto?',
        text: 'Esta acción no se puede deshacer',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ff3860',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.eliminar(id);
        }
      });
    },
    eliminar(id) {
      this.cargando = true;
      HttpService.registrar('productos.php', { accion: 'eliminar', id })
        .then(res => {
          if (res) {
            Swal.fire({
              icon: 'success',
              title: 'Eliminado',
              timer: 1500,
              showConfirmButton: false
            });
            this.obtenerProductos();
          }
        });
    }
  }
};
</script>

<style scoped>
.glass-container {
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  min-height: 80vh;
}

.glass-field /deep/ .label { 
  color: #94a3b8 !important; 
  font-weight: 500;
}

.glass-field /deep/ .select select {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border-radius: 12px !important;
}

.glass-field /deep/ .select select option {
  background: #1e293b;
  color: white;
}

.glass-table /deep/ .table {
  background: transparent !important;
  color: white !important;
}

.glass-table /deep/ .table thead th {
  background: rgba(255, 255, 255, 0.03) !important;
  color: #3b82f6 !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  padding: 15px;
}

.glass-table /deep/ .table td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.9);
  padding: 15px;
}

.glass-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.2);
}

.glass-action {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #94a3b8 !important;
  transition: all 0.3s ease;
}

.glass-action:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.glass-tag-info {
  background: rgba(59, 130, 246, 0.1) !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
  color: #60a5fa !important;
}

.is-success.tag { background-color: #10b981 !important; }
.is-danger.tag { background-color: #ef4444 !important; }

.shadow-soft {
  box-shadow: 0 8px 20px rgba(0,0,0,0.3);
}

@media screen and (max-width: 768px) {
  .section { padding: 15px 10px; }
  .glass-container { padding: 20px; }
}
</style>
